/**
 * Created by Michał Stawski on 2018-01-10.
 */
import React from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core'

class PopupDialog extends React.Component {
  render () {
    let {
      actionName,
      handleClose, handleYes, handleNo,
      message, title,
      ...props
    } = this.props
    return (
      <div>
        <Dialog
          // open={open}
          onClose={handleClose}
          aria-labelledby="form-dialog-title"
          {...props}
        >
          <DialogTitle id="form-dialog-title">
            {title || actionName}
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              {message}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => {
              handleYes()
              handleClose()
            }} color="primary">
              DONE
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    )
  }
}

export default PopupDialog

